<template>
  <div class="draft-box">
    <header-comp></header-comp>
    <div class="detail-container">
      <div class="detail-content">
        <div class="detail-left">
          <div class="left-draft right-draft">
            <div class="change-buttons" v-if="castDetailObj.matrixUrl && castDetailObj.videoUrl">
              <div class="change-button" style="margin-right: 20px;" @click="viewPreviewUrl('simple')" :class="showImgType === 'simple' && 'current-bg'">
                <img src="../../assets/imgs/common/root.png" class="change-icon" alt="icon">
                源母板
              </div>
              <div class="change-button" style="margin-right: 20px;" @click="viewPreviewUrl('videoUrl')" :class="showImgType === 'videoUrl' && 'current-bg'">
                <img src="../../assets/imgs/common/shiwaxi.png" class="change-icon" alt="icon">
                史瓦西聚合
              </div>
              <div class="change-button"  :class="showImgType === 'matrixUrl' && 'current-bg'" @click="viewPreviewUrl('matrixUrl')">
                <img src="../../assets/imgs/common/juzhen.png" class="change-icon" alt="icon">
                矩阵源
              </div>
            </div>
            <img class="draft-image" v-if="draftDetailObj.otherArtFlag === 1 && showImgType !== 'simple'" :src="showImgType === 'videoUrl' ? castDetailObj.videoUrl : castDetailObj.matrixUrl" alt="common">
            <glb-pc class="draft-image" :url="draftDetailObj.artInfoVO.artUrl" v-if="draftDetailObj.artInfoVO && draftDetailObj.artInfoVO.type.includes('glb') && showImgType === 'simple'"></glb-pc>
            <img :src="draftDetailObj.artInfoVO.artUrl" class="draft-image" alt="draft" v-if="draftDetailObj.artInfoVO && draftDetailObj.artInfoVO.type.includes('image') && showImgType === 'simple'">
            <video :src="draftDetailObj.artInfoVO.artUrl" class="draft-image" autoplay loop controls v-if="draftDetailObj.artInfoVO && draftDetailObj.artInfoVO.type.includes('audio') && showImgType === 'simple'"></video>
          </div>
        </div>
        <div class="detail-right-box">
          <div class="left-draft">
            <div class="left-title">
              源作品信息
            </div>
            <div class="left-content">
              <span>许可时间</span>
              <span>
                {{castDetailObj.createTime}}
              </span>
            </div>
            <div class="left-content cursor" @click="viewHash">
              <span>源母版DNA</span>
              <div class="right-desc">
                <span class="hash">
                  {{castDetailObj.digitalFingerprint && castDetailObj.digitalFingerprint.substr(0, 28) + '...'}}
                </span>
                <!-- <div class="copy" @click="copy" :data-clipboard-text="castDetailObj.digitalFingerprint">复制</div> -->
              </div>
            </div>
            <div class="left-content cursor" @click="viewHash" v-if="castDetailObj.recordAuditStatus == 1">
              <span>源母版区块位置</span>
              <div class="right-desc">
                <span class="hash">
                  {{castDetailObj.blockchainAddress ? castDetailObj.blockchainAddress.substr(0, 28) + '...' : '源母版区块位置生成中'}}
                </span>
                <!-- <div class="copy" @click="copy" :data-clipboard-text="castDetailObj.blockchainAddress">复制</div> -->
              </div>
            </div>
            <div class="left-content cursor" @click="viewHash" v-if="castDetailObj.matrixUrl && castDetailObj.videoUrl">
              <span>史瓦西聚合DNA</span>
              <div class="right-desc">
                <span class="hash">
                  {{videoHash && videoHash.substr(0, 28) + '...'}}
                </span>
                <!-- <div class="copy" @click="copy" :data-clipboard-text="videoHash">复制</div> -->
              </div>
            </div>
            <div class="left-content cursor" @click="viewHash" v-if="castDetailObj.matrixUrl && castDetailObj.videoUrl">
              <span>矩阵源DNA</span>
              <div class="right-desc">
                <span class="hash">
                  {{matrixHash && matrixHash.substr(0, 28) + '...'}}
                </span>
                <!-- <div class="copy" @click="copy" :data-clipboard-text="matrixHash">复制</div> -->
              </div>
            </div>
            <!-- <div class="footer-content">
              CNWW3公链
              <img style="width: 24px;height: 24px;margin:5px 10px;" src="../../assets/imgs/home/logo.png" />
              江苏省公证区块链
            </div> -->
            <buy-history v-if="isHistory" :list="castDetailObj.list"></buy-history>
          </div>
          <div class="create-btn-box" v-if="isHistory">
            <el-button type="primary" class="create-button" style="width:50%;" @click="create">
              {{authButtonText}}
            </el-button>
            <el-button type="primary" class="create-button down-btn" @click="download">
              下载源母版
            </el-button>
          </div>
          <div class="create-btn-box" v-else>
            <el-button type="primary" class="create-button" @click="create">
              {{authButtonText}}
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <drawer-create ref="drawer" @complate="backRoute"></drawer-create>
    <modal-view-hash ref="hash"></modal-view-hash>
    <modal-auth-apply ref="auth" @applyRecord="applyRecord"></modal-auth-apply>
    <modal-follow-wx ref="follow"></modal-follow-wx>
    <modal-create-again ref="again" @applyAgain="applyAgain"></modal-create-again>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import ModalAuthApply from '../../components/dialog/ModalAuthApply.vue'
import DrawerCreate from '../../components/center/saleManage/DrawerCreate.vue'
import Detail from '../../service/detail'
import GlbPc from '../../components/center/myArt/GlbPc.vue'
import HeaderComp from '../../components/index/HeaderComp.vue'
import BuyHistory from '../../components/center/saleManage/buyHistory.vue'
import ModalViewHash from '../../components/center/saleManage/ModalViewHash.vue'
import ModalFollowWx from '../../components/dialog/ModalFollowWx.vue'
import ModalCreateAgain from '../../components/dialog/ModalCreateAgain.vue'
import Home from '../../service/home'
export default {
  components: {
    GlbPc,
    BuyHistory,
    DrawerCreate,
    HeaderComp,
    ModalAuthApply,
    ModalViewHash,
    ModalFollowWx,
    ModalCreateAgain
},
  data() {
    return {
      draftDetailObj: {},
      castDetailObj: {},
      sellDetailObj: {},
      showImgType: 'simple',
      authButtonTextType: ''
    }
  },
  computed: {
    matrixHash () {
      if (!this.isUrlShow) return '' 
      const obj = this.draftDetailObj.list.find(item => {
        return item.infoType === 3
      }) || {}
      return obj.digitalFingerprint
    },
    videoHash () {
      if (!this.isUrlShow) return '' 
      const obj = this.draftDetailObj.list.find(item => {
        return item.infoType === 4
      }) || {}
      return obj.digitalFingerprint
    },
    isUrlShow () {
      return this.draftDetailObj.list instanceof Array && this.draftDetailObj.list.length > 0
    },
    isHistory () {
      return this.castDetailObj.list instanceof Array && this.castDetailObj.list.length > 0
    },
    castId () {
      return this.$route.query.castId
    },
    draftId () {
      return this.$route.query.draftId
    },
    authButtonText () {
      switch (this.authButtonTextType){
        case '1':
          return '开启许可'
        case '2':
          return '开启许可'
        case '3':
          return '已申请开启发售权限，请等待平台审核'
        default:
          return '开启许可'
      }
    }
  },
  mounted () {
    this.getArtDraftDetailById()
    this.getArtCastDetailById()
    this.getNftPower()
  },
  methods: {
    backRoute () {
      this.$router.push('/space/center/saleManage')
    },
    applyAgain () {
      this.$router.push('/space/center/myArt?draftId=' + this.draftId)
    },
    download () {
      const list = this.castDetailObj.list
      const id = list[list.length - 1].id
      Detail.getNftSrcFileInfo(id).then(res => {
        window.open(res)
      })
    },
    applyRecord () {
      Detail.createEnterpriseAudit().then(res => {
        if (res) {
          setTimeout(() => {
            this.$message.success('申请成功')
          }, 50)
          this.$refs.auth.hide()
          this.$refs.follow.show()
          this.getNftPower()
        }
      })
    },
    async getNftPower () {
      const auth = await Home.getNftPower()
      const status = await Detail.getEnterpriseAudit()
      if (auth === '00' || auth === '10') {
        this.authButtonTextType = '1'// 申请许可已通过
        return
      }
      if ((auth === '11' || auth === '01') && (!status || status.auditStatus === 0 || status.auditStatus === 1)) {
        this.authButtonTextType = '2'// 需要申请许可
        return
      }
      if ((auth === '11' || auth === '01') && status.auditStatus === 2) {
        this.authButtonTextType = '3'// 申请许可待审核
      }
    },
    create () {
      if (this.authButtonTextType === '2') {
        this.$refs.auth.show()
        return
      }
      if (this.authButtonTextType === '3') {
        this.$refs.follow.show()
        return
      }
      if (this.castDetailObj.recordAuditStatus == 2) {
        this.$refs.again.show()
        return
      }
      const list = this.castDetailObj.list || []
      if (list instanceof Array && list.length > 0 && list[list.length - 1].remainingCount !== 0) {
        this.$message.error('上一批许可未售罄，暂不支持继续许可')
        return
      }
      if (this.sellDetailObj.permitType && this.sellDetailObj.permitType.toString() === '2') {
        this.$message.error('该作品已专有许可，不支持再次许可')
        return
      }
      this.$refs.drawer.show()
    },
    viewPreviewUrl (showImgType) {
      this.showImgType = showImgType
    },
    viewHash () {
      const data = {
        digitalFingerprint:this.castDetailObj.digitalFingerprint,
        blockchainAddress:this.castDetailObj.blockchainAddress,
        videoHash:this.videoHash,
        matrixHash:this.matrixHash
      }
      this.$refs.hash.show(data)
    },
    copy () {
      const clipboard = new Clipboard('.copy')
      clipboard.on('success', () => {
        this.$message({
          message: '复制成功',
          type: 'success'
        })
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$message.error('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    },
    getArtDraftDetailById () {
      Detail.getArtDraftDetailById(this.draftId).then(res => {
        this.draftDetailObj = res
      })
    },
    getArtCastDetailById () {
      Detail.getArtCastDetailById(this.castId).then(res => {
        this.castDetailObj = res
        const list = res.list
        if (!this.isHistory) return {}
        const id = list[list.length - 1].id
        return Detail.getArtSellDetailById(id)
      }).then(res => {
        this.sellDetailObj = res
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .row-box{
    border-top: #343A3F 1px solid;
    width: 100%;
    margin-top: 80px;
  }
  ::-webkit-scrollbar {
    width: 0 !important;
  }
  .detail-container{
    width: 100%;
    min-height: 855px;
    margin-top: 81px;
    border-top: 1px solid #343A3F;
    display: flex;
    justify-content: center;
    font-size: 14px;
  }
  .current-bg{
    background-color: $sub-color !important;
  }
  .create-button{
    width: 100%;
    height: 100%;
    outline: none;
    border: none;
  }
  .change-buttons{
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: -2%;
    bottom: 100px;
  }
  .change-button{
    display: inline-flex;
    padding: 10px 20px;
    background-color: $line;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    cursor: pointer;
  }
  .change-icon{
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }
  .footer-content{
    display: flex;
    margin: 20px 0;
    justify-content: center;
    align-items: center;
  }
  .copy{
    width: 50px;
    height: 24px;
    border-radius: 4px;
    color: $btn-font-color;
    background-image: linear-gradient(to right,$linear-sub-btn1,$linear-sub-btn2);
    text-align: center;
    line-height: 24px;
    font-size: 12px;
    color: $button-bg;
    cursor: pointer;
    display: inline-block;
  }
  .right-desc{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .draft-box{
    box-sizing: border-box;
    color: #fff;
    position: fixed;
    background-color: $background;
    z-index: 120;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0;
    margin: 0;
  }
  .left-draft{
    height: 800px;
    border-radius: 16px;
    padding: 20px;
    box-sizing: border-box;
    overflow-y: scroll;
  }
  .down-btn{
    width:50%;
    background-color:#ffd38b;
    color:#68400B;
  }
  .right-draft{
    display: flex;
    justify-content: center;
    align-items: flex-start;
    position: relative;
  }
  .left-title{
    font-size: 18px;
    font-weight: 700;
    color: #fff;
    margin-bottom: 20px;
  }
  .left-content{
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    height: 40px;
    margin-top: 10px;
    color: $sub-font-color;
  }
  .cursor{
    cursor: pointer;
  }
  .hash{
    margin-right: 10px;
    color:#FCDFB3;
    max-width: 240px;
    word-wrap: break-word; 
    word-break: break-all;
  }
  .draft-image, .draft-image::v-deep .wrapper{
    width: 400px;
    height: 400px;
    border-radius: 20px !important;
    overflow: hidden;
  }
  .detail-left{
    width: 800px;
    border-right: 1px solid #343A3F;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .detail-right-box{
    // height: 775px;
    overflow-y: scroll;
    box-sizing: border-box;
    width: 550px;
    padding: 20px;
    position: relative;
  }
  .detail-content{
    width: 1350px;
    box-sizing: border-box;
    border-right: 1px solid #343A3F;
    border-left: 1px solid #343A3F;
    position: relative;
    display: flex;
  }
  .create-btn-box{
    width: 100%;
    height: 80px;
    background: $line;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-content: center;
  }
</style>